
import React from 'react'
import { Link,useLocation ,useNavigate} from "react-router-dom";
const Layout = ({children}) => {
    const location = useLocation();
    const history = useNavigate();
    
    const fuser = localStorage.getItem('user');
    const user =JSON.parse(fuser)
  const handleLogout = () => {
    localStorage.removeItem('sessionToken');
    history('/');
  };

  return (
    <div>
  <div>
           <header className="main-header">
          <a href="index2.html" className="logo">
          <span className="logo-mini"><b>{user?.short}</b></span>
            <span className="logo-lg"><b></b>{user?.company}</span>  </a>
          <nav className="navbar navbar-static-top">
            <a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button">
              <span className="sr-only">Toggle navigation</span>
            </a>
            <div className="navbar-custom-menu">
              <ul className="nav navbar-nav">
                <li className="dropdown user user-menu">
                  <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                    <img src="dist/img/user2-160x160.jpg" className="user-image" alt="User Image" />
                    <span className="hidden-xs"> <span className="hidden-xs">{user.username}</span>
                </span>
                  </a>
                  <ul className="dropdown-menu">
                    <li className="user-header">
                      <img src="dist/img/user2-160x160.jpg" className="img-circle" alt="User Image" />
                      <p>
                        Alexander Pierce - Web Developer
                        <small>Member since Nov. 2012</small>
                      </p>
                    </li>
                
                    <li className="user-footer">
                      <div className="pull-left">
                        <a href="#" className="btn btn-default btn-flat">Profile</a>
                      </div>
                      <div onClick={handleLogout} className="pull-right">
                        <a href="#" className="btn btn-default btn-flat">Sign out</a>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </header>
    </div>
    <div>
          <aside className="main-sidebar">
          <section className="sidebar">
    
            <div style={{margin:'0px'}}/>        
            <ul className="sidebar-menu" data-widget="tree">
            <li className={location.pathname==="/pharmadashboard"?"active":""}>
            <Link to="/pharmadashboard">
    <i className="fa fa-dashboard" /> <span> Dashboard   </span>
    <span className="pull-right-container">
   
    </span>
    </Link>
</li>


<li  className={location.pathname==="/pos"?"active":""}>
            <Link to="/pos">
    <i className="fa fa-money" /> <span> Pos   </span>
    <span className="pull-right-container">
      
    </span>
    </Link>
</li>

<li  className={location.pathname==="/transaction"?"active":""}>
            <Link to="/transaction">
    <i className="fa fa-money" /> <span> Transaction   </span>
    <span className="pull-right-container">
      
    </span>
    </Link>
</li>

<li  className={location.pathname==="/dateset"?"active":""}>
            <Link to="/dateset">
    <i className="fa fa-money" /> <span> Date set   </span>
    <span className="pull-right-container">
      
    </span>
    </Link>
</li>


            </ul>
          </section>
        </aside>
    </div>

    

    <div className="content-wrapper">


{children}
 </div>
 <div>
           
    </div>
     
       
    </div>
  )
}

export default Layout